export interface ZyndayDemoProfile {
  readonly branchId: string;
  readonly organizerEmail: string;
  readonly contactEmail: string;
  readonly introductionHtml: string;
}

export type ZyndayDemoEnvironment =
  | 'production'
  | 'stage'
  | 'staging'
  | 'development'
  | 'local';

const CANONICAL_INTRODUCTION_HTML = `
<section aria-labelledby="zynday-demo-introduction-heading">
  <h2 id="zynday-demo-introduction-heading">Lass uns über deinen Salon sprechen.</h2>
  <p>Jeder Salon arbeitet anders – deshalb ist auch jede Demo anders.</p>
  <p>In einem unverbindlichen Gespräch lernen wir zuerst deinen Salon und deine Arbeitsweise kennen. Anschließend zeigen wir dir genau die Bereiche von zynday, die für dich wirklich relevant sind.</p>
  <h3>Das erwartet dich:</h3>
  <ul>
    <li>Eine kurze Vorstellung von zynday und unserer Vision.</li>
    <li>Wir sprechen über deine aktuellen Herausforderungen und Prozesse.</li>
    <li>Wir zeigen dir genau die Funktionen, die diese Herausforderungen lösen können.</li>
    <li>Natürlich beantworten wir alle deine Fragen – egal ob zu Funktionen, Preisen oder dem weiteren Ablauf.</li>
  </ul>
  <p><em>30 Minuten · Online · Unverbindlich</em></p>
  <p><strong>→ Finde deinen passenden Termin</strong></p>
  <p><em>Wähle einfach einen freien Zeitslot – wir kümmern uns um den Rest.</em></p>
</section>
`.trim();

export const ZYNDAY_DEMO_PROFILES = {
  stage: {
    branchId: 'c1c217b941e24ad',
    organizerEmail: 'rip3x2@gmail.com',
    contactEmail: 'contact@zynday.com',
    introductionHtml: CANONICAL_INTRODUCTION_HTML,
  },
  production: {
    branchId: '29a678d1137949e',
    organizerEmail: 'jannis@zynday.org',
    contactEmail: 'contact@zynday.com',
    introductionHtml: CANONICAL_INTRODUCTION_HTML,
  },
} as const satisfies Record<'stage' | 'production', ZyndayDemoProfile>;

/** Resolve the shared profile for browser and backend environment names. */
export function resolveZyndayDemoProfile(
  environment: ZyndayDemoEnvironment,
): ZyndayDemoProfile {
  return environment === 'production'
    ? ZYNDAY_DEMO_PROFILES.production
    : ZYNDAY_DEMO_PROFILES.stage;
}
